

export const parentDivClasses = 'w-full  items-center justify-evenly flex flex-wrap pt-0 px-5';

export const titleAndTextSection = 'left_part text-center space-y-5 py-10';
